<template>
  <div class="bg">
    <div class="container">
      <div class="content">
        <div class="content-header">
          <div class="car-title">当前学习课程</div>
          <div class="car-buton" @click="$router.go(-1)">
            <img src="@/assets/image/next.png" alt="" />
            返回
          </div>
        </div>
        <div class="content-body">
          <div class="video">
            <video-player
              class="video-player vjs-custom-skin"
              ref="videoPlayer"
              :playsinline="true"
              :options="playerOptions"
              @play="onPlayerPlay($event)"
              @pause="onPlayerPause($event)"
              @timeupdate="onPlayerTimeupdate($event)"
              @ended="onPlayerEnded($event)"
            ></video-player>
          </div>
          <div class="ml">
            <h3 class="ml-title">目录</h3>
            <div
              :class="{ active: index === activeChapter }"
              v-for="(item, index) in videoList"
              :key="index"
              @click="qh(item, index)"
            >
              <span v-if="item.video">
                {{ item.video.videoName }}
              </span>
              <span
                v-if="
                  item.position &&
                  item.position.videoPosition &&
                  item.position.videoTime
                "
              >
                {{
                  `${
                    (
                      item.position.videoPosition / item.position.videoTime
                    ).toFixed(2) * 100
                  }%`
                }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { videoPlayer } from "vue-video-player";
import "videojs-contrib-hls";
import "video.js/dist/video-js.css";
import "vue-video-player/src/custom-theme.css";
import api from "../../api";
import cookie from "@/api/cookie";

export default {
  name: "index",
  data() {
    return {
      videoList: [],
      videoInfo: {},
      activeChapter: 0,
      playerOptions: {
        language: "zh-CN",
        aspectRatio: "16:9",
        sources: [],
      },
      paused: true,
    };
  },
  components: {
    videoPlayer,
  },
  mounted() {
    this.hiddenProperty =
      "hidden" in document
        ? "hidden"
        : "webkitHidden" in document
        ? "webkitHidden"
        : "mozHidden" in document
        ? "mozHidden"
        : null;
    // this.visibilityChangeEvent = this.hiddenProperty.replace(/hidden/i, 'visibilitychange')
    // document.addEventListener(this.visibilityChangeEvent)//, this.onVisibilityChange
    // this.timer = setInterval(() => {
    //   this.addChapterPlay(this.player)
    // }, 3000)
  },
  destroyed() {
    // if (this.timer) {
    //   clearInterval(this.timer)
    // }
  },
  computed: {
    player() {
      return this.$refs.videoPlayer.player;
    },
  },
  watch: {
    videoInfo(data) {
      // console.log(data)
      if (data) {
        this.playerOptions.sources = [
          {
            type:
              data.videoUrl.indexOf("m3u8") === -1
                ? "video/mp4"
                : "application/x-mpegURL",
            src: data.videoUrl,
          },
        ];
      }
      // if (data.position) {
      // this.beforeTime = data.position.videoPosition;
      //   // setTimeout(() => {
      //   //     this.player.currentTime(data.videoPosition.position);
      //   // }, 50);
      // }
    },
  },
  beforeDestroy() {
    // this.addChapterPlay(this.player)
    // document.removeEventListener(this.visibilityChangeEvent)//this.onVisibilityChange)
  },
  methods: {
    getVideo() {
      api
        .courseVideo(
          cookie.getCookie("userId"),
          this.$route.query.classId,
          this.$route.query.id
        )
        .then((res) => {
          console.log("courseVideo", res.data);
          this.videoList = res.data;
          this.videoInfo = res.data[0].video;
          // this.videoInfo.position = res.data[0].position
        });
    },
    // onVisibilityChange() { // 检测当前页面是否显示
    //   if (!document[this.hiddenProperty]) {
    //     this.player.play()
    //   } else {
    //     this.player.pause()
    //   }
    // },
    // eslint-disable-next-line no-unused-vars
    onPlayerPlay(player) {
      this.paused = false;
      if (this.currentTime) {
        this.player.currentTime(this.currentTime);
      }
    },
    // eslint-disable-next-line no-unused-vars
    onPlayerTimeupdate(player) {
      // this.disabledSeek(player)
    },
    // eslint-disable-next-line no-unused-vars
    onPlayerPause(player) {
      this.paused = true;
      // this.flush()
    },
    onPlayerEnded(player) {
      // 播放结束
      this.paused = true;
      //   this.addChapterPlay(player);
      // this.flush();
      this.playerOptions.controls = true;
    },
    // disabledSeek(player) {
    //   //禁止跳转
    //   let beforeTime = this.beforeTime || 0;
    //   if (player.cache_.currentTime - beforeTime >= 2) {
    //     this.player.currentTime(this.beforeTime);
    //   } else {
    //     this.beforeTime = player.cache_.currentTime;
    //   }
    //   // this.beforeTime = player.cache_.currentTime;
    // },
    // addChapterPlay(player) {
    //   // 记录进度
    //   if (!this.paused) {
    //     api.addChapterPlay({
    //       userId: cookie.getCookie('userId'),
    //       videoId: this.videoInfo.videoId,
    //       videoPosition: player.cache_.currentTime,
    //       videoTime: player.cache_.duration,
    //       watchEnd: 0
    //     }).then(res => {
    //       // console.log(res.data)
    //     });
    //   }
    // },
    chapterInfo(query) {
      this.activeChapter = Number(query.index);
      console.log(this.activeChapter);
    },
    qh(data, index) {
      this.activeChapter = index;
      console.log(this.activeChapter);
      // console.log(data)
      this.videoInfo = data.video;
      // this.videoInfo.position = data.position;
    },
    // flush() {
    //   api.flush(this.$route.query.id, cookie.getCookie('userId'), this.videoInfo.videoId,2020).then(res => {
    //     console.log(res)
    //   })
    // },
    // fh() {
    //   this.flush()
    //   this.$router.push('/learn')
    // }
  },
  created() {
    let query = this.$route.query;
    this.getVideo();
    this.chapterInfo(query);
  },
};
</script>

<style lang="scss" scoped>
.vjs-big-play-button {
  top: 50% !important;
  left: 50% !important;
  margin: -0.75em 0 0 -1.5em !important;
}
.content {
  width: 1200px;
  margin: 20px auto;
  background: #ffffff;
  padding: 20px;
  .content-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;

    .car-title {
      position: relative;
      text-align: left;
      padding-left: 8px;
      height: 22px;
      font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
      font-weight: 400;
      font-size: 16px;
      color: #264f99;
      line-height: 22px;
      text-align: justify;
      font-style: normal;
    }
    .car-title::before {
      content: "";
      width: 4px;
      height: 12px;
      background: #264f99;
      display: block;
      position: absolute;
      top: 6px;
      left: 0px;
    }

    .car-buton {
      display: flex;
      align-items: center;
      cursor: pointer;
      img {
        width: 18px;
        height: 22px;
        margin-right: 6px;
      }
      font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
      font-weight: 400;
      font-size: 16px;
      color: #999999;
      line-height: 22px;
      text-align: justify;
      font-style: normal;
    }
  }

  .content-body {
    display: flex;
    align-items: center;
    .video {
      width: 890px;
    }
    .ml {
      width: 310px;
      height: 492px;
      text-align: left;
      padding-bottom: 20px;
      box-sizing: border-box;
      margin-left: 20px;
      border-left: 1px solid #eaeaeb;
      padding: 5px 20px;

      .ml-title {
        font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
        font-weight: 400;
        font-size: 16px;
        color: #333333;
        line-height: 22px;
        font-style: normal;
        margin: 0px 0px 10px 0px;
      }
      span {
        display: block;
        cursor: pointer;
        font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
        font-weight: 400;
        font-size: 12px;
        color: #666666;
        line-height: 24px;
        font-style: normal;
      }
      .active {
        span {
          color: #5172ad;
          font-weight: 600;
        }
      }
    }
  }
}

::v-deep .vjs-custom-skin > .video-js .vjs-big-play-button {
  width: 60px !important;
  height: 60px !important;
  border-radius: 50%;
  line-height: 60px !important;
}
</style>
